import { PaymentSummary, SaleTransaction } from './transactionTypes';
import { getDefaultPaymentMethod } from './paymentMethodUtils';

export const processCreditPayments = (
  transaction: SaleTransaction,
  summariesMap: Map<string, PaymentSummary>
): void => {
  if (transaction.credit_payments && transaction.credit_payments.length > 0) {
    transaction.credit_payments.forEach((payment) => {
      const method = payment.payment_method || 'Espèces'; // Default to cash if no method specified
      const existing = summariesMap.get(method) || { 
        method, 
        amount: 0, 
        transactions: [],
        isValidated: false
      };
      
      existing.amount += payment.amount;
      if (existing.transactions) {
        existing.transactions.push({
          id: `${transaction.id}-payment-${payment.payment_date}`,
          date: payment.payment_date,
          amount: payment.amount,
          type: "credit_payment",
          notes: `Paiement de crédit`
        });
        
        existing.transactions.sort((a, b) => 
          new Date(b.date).getTime() - new Date(a.date).getTime()
        );
      }
      
      summariesMap.set(method, existing);
    });
  }

  // Add paid amount to credit summary instead of remaining amount
  if (!transaction.is_fully_paid) {
    const paidAmount = transaction.paid_amount || 0;
    const creditMethod = "Crédit";
    const creditSummary = summariesMap.get(creditMethod) || {
      method: creditMethod,
      amount: 0,
      transactions: [],
      isValidated: false
    };

    creditSummary.amount += paidAmount;
    if (creditSummary.transactions) {
      creditSummary.transactions.push({
        id: `${transaction.id}-credit`,
        date: transaction.created_at,
        amount: paidAmount,
        type: "credit_sale",
        notes: transaction.notes
      });
      
      creditSummary.transactions.sort((a, b) => 
        new Date(b.date).getTime() - new Date(a.date).getTime()
      );
    }
    
    summariesMap.set(creditMethod, creditSummary);
  }
};